import { Link } from "react-router-dom";
import { Check, Award, HeartHandshake, Sparkles } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import CtaBand from "@/components/site/CtaBand";
import SEO from "@/components/site/SEO";
import { COMPANY, VALUES } from "@/lib/siteData";

export default function APropos() {
  return (
    <div data-testid="apropos-page">
      <SEO
        title="À propos - Artisan plombier Colmar, Mulhouse, Strasbourg | RM Plomberie"
        description="Ramzi Latrach, artisan plombier chauffagiste, dirige RM Plomberie Chauffage VMC à Beblenheim. Interventions à Colmar, Mulhouse, Strasbourg et tout le Haut-Rhin. Sérieux, réactivité, qualité."
        keywords="Ramzi Latrach plombier, artisan plombier Colmar, entreprise plomberie Mulhouse, plombier de confiance Strasbourg, artisan Haut-Rhin, plombier certifié Alsace, RM Plomberie Beblenheim"
      />
      <PageHero
        breadcrumb="À propos"
        title=" propos"
        highlight="À"
        subtitle="Découvrez RM Plomberie Chauffage VMC, votre artisan de confiance basé à Beblenheim."
        useLogo
      />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-xs uppercase tracking-[0.28em] font-semibold text-[#005BBB] mb-3">Notre histoire</p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#001B35] leading-tight">
              Un artisan engagé, à votre <span className="text-[#005BBB]">service</span>
            </h2>
            <div className="mt-4 w-16 h-1 bg-[#005BBB] rounded-full" />
            <p className="mt-7 text-gray-700 leading-relaxed">
              Fondée par <strong>{COMPANY.founder}</strong>, RM Plomberie Chauffage VMC accompagne particuliers et professionnels avec sérieux, réactivité et professionnalisme. L'entreprise intervient à Beblenheim, Colmar, Mulhouse, Strasbourg et dans tout le Haut-Rhin.
            </p>
            <p className="mt-4 text-gray-700 leading-relaxed">
              De l'installation à l'entretien, en passant par le dépannage et la rénovation, nous vous proposons une expertise complète en plomberie, chauffage et VMC, avec une exigence constante : un travail propre et durable.
            </p>

            <div className="mt-8 grid sm:grid-cols-3 gap-4">
              {[
                { num: "100%", label: "Satisfaction client" },
                { num: "7j/7", label: "Disponibilité" },
                { num: "0€", label: "Déplacement" },
              ].map((s) => (
                <div key={s.label} className="bg-[#F5F7FA] rounded-2xl p-5 text-center">
                  <p className="font-display text-3xl font-bold text-[#005BBB]">{s.num}</p>
                  <p className="text-xs uppercase tracking-wider text-gray-600 mt-1">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="aspect-square rounded-2xl overflow-hidden shadow-2xl bg-[#001B35] relative flex items-center justify-center p-8">
              <div className="absolute -top-16 -right-16 w-72 h-72 bg-[#005BBB] rounded-full blur-3xl opacity-30" />
              <div className="absolute -bottom-16 -left-16 w-72 h-72 bg-[#D90000] rounded-full blur-3xl opacity-20" />
              <img
                src="/logo-rm.jpg"
                alt="Logo RM Plomberie Chauffage VMC"
                className="relative w-full h-full object-contain rounded-2xl"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#001B35] text-white p-6 rounded-2xl shadow-xl max-w-[220px] hidden sm:block border border-white/10">
              <Sparkles className="w-6 h-6 text-[#5dade2] mb-2" />
              <p className="font-display font-bold text-sm uppercase tracking-wider">Artisan local</p>
              <p className="text-xs text-[#9bb6d6] mt-1">Haut-Rhin (68) — Alsace</p>
            </div>
          </div>
        </div>
      </section>

      {/* VALEURS */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <p className="text-xs uppercase tracking-[0.28em] font-semibold text-[#005BBB] mb-3">Nos valeurs</p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#001B35]">
              Ce qui nous tient à <span className="text-[#005BBB]">cœur</span>
            </h2>
            <div className="mt-4 w-16 h-1 bg-[#005BBB] mx-auto rounded-full" />
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {VALUES.map((v, i) => (
              <div key={v.label} className="rm-card bg-white rounded-2xl p-6 border border-gray-100">
                <div className="w-10 h-10 rounded-xl bg-[#005BBB]/10 flex items-center justify-center mb-4">
                  <Check className="w-5 h-5 text-[#005BBB]" />
                </div>
                <p className="font-display font-bold text-[#001B35] uppercase text-sm tracking-wider">{v.label}</p>
                <p className="text-sm text-gray-600 mt-2 leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
